<template lang="pug">
div.listagem-exportacao-planta-memorial-comissao
  el-card.card-container(shadow="hover")
    .painel-filtros
      el-row(type="flex" :gutter="10")
        el-col(:lg="8" :md="8" :sm="24")
          p.titulo
            | Município:
            span.obrigatorio  *
          el-select.full-width(
            v-model="idMunicipio",
            placeholder="Selecione",
            clearable,
            filterable,
            :disabled="filtrosDesabilitadosPorPlanilha",
            no-match-text="Município não encontrado",
            @clear="onClearMunicipio"
          )
            el-option(
              v-for="m in municipios",
              :key="m.id",
              :label="m.nome",
              :value="m.id"
            )
        el-col(:lg="8" :md="8" :sm="24")
          p.titulo REURB coletivo:
          el-select.full-width(
            v-model="idReurbColetivo",
            placeholder="Selecione",
            clearable,
            filterable,
            :disabled="filtrosDesabilitadosPorPlanilha || !idMunicipio",
            no-match-text="REURB não encontrado"
          )
            el-option(
              v-for="reurb in reurbColetivos",
              :key="reurb.id",
              :label="labelReurb(reurb)",
              :value="reurb.id"
            )
        el-col(:lg="8" :md="8" :sm="24")
          p.titulo Bairro:
          el-select.full-width(
            v-model="bairroSelecionado",
            placeholder="Selecione o reurb coletivo primeiro",
            clearable,
            filterable,
            :disabled="filtrosDesabilitadosPorPlanilha || !idMunicipio || bairrosDoMunicipio.length === 0",
            no-match-text="Bairro não encontrado"
          )
            el-option(
              v-for="b in bairrosDoMunicipio",
              :key="b.nome",
              :label="b.nome",
              :value="b.nome"
            )
      el-row(type="flex" :gutter="10")
        el-col(:lg="8" :md="8" :sm="24")
          p.titulo Quadra:
          el-select.full-width(
            v-model="quadraSelecionada",
            placeholder="Selecione o bairro primeiro",
            clearable,
            filterable,
            :disabled="filtrosDesabilitadosPorPlanilha || !idMunicipio || !bairroSelecionado || quadras.length === 0",
            no-match-text="Quadra não encontrada"
          )
            el-option(
              v-for="q in quadras",
              :key="q",
              :label="q",
              :value="q"
            )
        el-col(:lg="8" :md="8" :sm="24")
          p.titulo Setor:
          el-select.full-width.select-tags-ellipsis(
            v-model="setorSelecionado",
            placeholder="Selecione",
            multiple,
            collapse-tags,
            clearable,
            filterable,
            :disabled="filtrosDesabilitadosPorPlanilha || !idMunicipio",
            no-match-text="Setor não encontrado"
          )
            el-option(
              v-for="s in setores",
              :key="s.codigo",
              :label="s.nome",
              :value="s.codigo"
            )
        el-col(:lg="8" :md="8" :sm="24")
          p.titulo Situação:
          el-select.full-width.select-tags-ellipsis(
            v-model="statusSelecionado",
            placeholder="Selecione",
            multiple,
            collapse-tags,
            clearable,
            filterable,
            :disabled="filtrosDesabilitadosPorPlanilha || !idMunicipio",
            no-match-text="Situação não encontrada"
          )
            el-option(
              v-for="s in situacoes",
              :key="s.codigo",
              :label="s.nome",
              :value="s.codigo"
            )
      el-row(type="flex" :gutter="10")
        el-col(:lg="8" :md="8" :sm="24")
          p.titulo Nome do interessado:
          el-input.full-width(
            v-model="nomeInteressado",
            clearable,
            :disabled="filtrosDesabilitadosPorPlanilha || !idMunicipio"
          )
        el-col(:lg="8" :md="8" :sm="24")
          p.titulo CPF/CNPJ do Interessado:
          el-input.full-width(
            v-model="cpfCnpjInteressado",
            clearable,
            :disabled="filtrosDesabilitadosPorPlanilha || !idMunicipio"
            v-mask="['###.###.###-##', '##.###.###/####-##']"
          )
        el-col(:lg="8" :md="8" :sm="24")
          p.titulo Processo:
          el-input.full-width(
            v-model="numeroProcessoFiltro",
            clearable,
            :disabled="filtrosDesabilitadosPorPlanilha || !idMunicipio",
            v-mask="['#########/####']"
          )
      el-row(:gutter="10")
        div.row
          span(@click="exibirBuscaPorLote")
            p.busca Pesquisa por lote
          el-tooltip(
            effect='dark',
            placement="top-end"
          )
            i.el-icon-info.icon-info
            template(slot="content") Para realizar a pesquisa de mais de um processo, insira a planilha contendo os números dos processos a serem pesquisados de acordo com o modelo a seguir.&nbsp
              a.btn-download(@click="baixarModelo") (Baixar modelo)
        div
          app-upload-area(
            v-if="showPesquisaLote",
            id="lote",
            :target="'publico/upload'"
            :fileType="validExtensions"
            :onSuccess="onSuccess"
            :documento="file"
            :hasDownloadButton="false",
            v-model="file"
            @removerDocumento="limparFiltro"
          )
      el-row.button-row
        el-button(@click="limparFiltro") Limpar

        el-button(type="primary" @click="aplicarFiltro" :disabled="!podeAplicar" :loading="carregando")
          i.icon(class="fa fa-search")
          |  Aplicar filtro

  el-card.mt-1(shadow="hover" v-if="!filtroObrigatorioAplicado")
    el-alert(
      title="Como usar",
      type="info",
      :closable="false",
      show-icon,
      :description="textoOrientacao"
    )

  div.mt-1(v-loading="filtroObrigatorioAplicado && carregando")
    app-listagem(
      caixa="LISTAGEM_EXPORTACAO_PLANTA_MEMORIAL"
      :has-refresh-button="true",
      :has-filtro-rapido="false",
      :ids-disabled-checkbox="idsProcessosNaoElegiveisZip",
      :show-exportar-zip-button="true",
      :loading-baixar-zip-planta-memorial="gerandoZip",
      :disable-baixar-todos-zip-planta-memorial="!filtroObrigatorioAplicado || totalElements == 0",
      :disable-baixar-selecionados-zip-planta-memorial="!podeBaixarSelecionadosZip",
      :json-headers="colunas",
      :json-data="items",
      :totalElements="totalElements",
      :pagina="listagemFiltro.pagina",
      :filtro="filtroListagem",
      :dados-nao-encontrado="textoVazioTabela",
      @atualizarFiltro="onAtualizarFiltroRapido",
      @updateListagem="onRefreshListagem",
      @changePage="onChangePage",
      @executar="onExecutarListagem",
      @sort="onSort",
      @baixarTodosZipPlantaMemorial="baixarTodosZip",
      @baixarSelecionadosZipPlantaMemorial="baixarSelecionadosZip"
    )

  app-modal-visualizar-completo(
    v-if="showModalVisualizarProcesso && idProcesso !== null"
    @closeModal="showModalVisualizarProcesso = false"
    :idProcesso="idProcesso"
    :protocolo="protocolo"
    :numeroProcesso="numeroProcesso"
    :tipo="tipoProcesso"
  )
</template>

<script>
import { mapActions } from 'vuex'
import AppListagem from '@/components/AppListagem'
import AppUploadArea from '@/components/AppUploadArea'
import AppModalVisualizarCompleto from '@/screens/analise/components/modal/AppModalVisualizarCompleto'
import { getItem, KEYS } from '@/store/local/localStorage'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import CONFIGS from '@/constants/configs'
import {
  listarSetoresFiltroExportacaoPlantaMemorial,
  listarSituacoesFiltroExportacaoPlantaMemorial
} from '@/utils/ma/exportacaoPlantaMemorialComissaoFiltros'
const { setoresFormatado } = require('@/utils/' + process.env.ESTADO + '/setor').default

const unwrapJson = (res) => {
  if (res == null) return res
  if (res.data !== undefined && res.data !== null && typeof res === 'object' && !Array.isArray(res) && 'data' in res) {
    return res.data
  }
  return res
}

export default {
  name: 'ListagemExportacaoPlantaMemorialComissao',

  components: { AppListagem, AppUploadArea, AppModalVisualizarCompleto },

  mixins: [AppNotificacao],

  data () {
    return {
      idMunicipio: null,
      idReurbColetivo: null,
      bairroSelecionado: null,
      quadraSelecionada: null,
      quadras: [],
      setorSelecionado: [],
      statusSelecionado: [],
      nomeInteressado: null,
      cpfCnpjInteressado: null,
      numeroProcessoFiltro: null,
      setores: [],
      situacoes: [],
      municipios: [],
      reurbColetivos: [],
      mapListMunicipiosBairros: [],
      filtroObrigatorioAplicado: false,
      carregando: false,
      items: [],
      totalElements: 0,
      listagemFiltro: {
        pagina: 0,
        ordem: 'numeroProcesso',
        ordemDirecao: 'ASC'
      },
      showModalVisualizarProcesso: false,
      idProcesso: null,
      protocolo: '',
      numeroProcesso: '',
      tipoProcesso: '',
      gerandoZip: false,
      processosSelecionadosZip: [],
      showPesquisaLote: false,
      file: null,
      nomePlanilha: null,
      nomePlanilhaAplicado: null,
      validExtensions: process.env.ESTADO === 'ma' ? ['xlsx'] : ['xlsx', 'xls', 'csv'],
      colunas: [
        { id: 0, titulo: 'Processo', propriedade: 'numeroProcesso', marcado: () => true, ordem: 1, acoes: [], type: 'icone', icone: 'comment-alt', sortable: true },
        { id: 1, titulo: 'CPF/CNPJ do interessado', propriedade: 'cpfCnpjInteressado', ordem: 2, acoes: [], sortable: false },
        { id: 2, titulo: 'Núcleo ou nome do interessado', propriedade: 'nomeRazaoSocialInteressado', ordem: 3, acoes: [], sortable: true },
        { id: 3, titulo: 'Situação', propriedade: 'status', ordem: 4, acoes: [], sortable: false },
        { id: 4, titulo: 'Município', propriedade: 'municipio', sortable: false, ordem: 5, acoes: [] },
        { id: 5, titulo: 'Tipo de processo', propriedade: 'tipo', ordem: 6, acoes: [], sortable: false },
        { id: 6, titulo: 'Setor', propriedade: 'setor', ordem: 7, acoes: [], formatter: this.formataSetor, sortable: false },
        { id: 7, titulo: 'Data de atualização', propriedade: 'dataAlteracao', ordem: 8, acoes: [], sortable: true },
        { id: 8, titulo: 'Responsável', propriedade: 'responsavel', ordem: 9, acoes: [], sortable: false },
        {
          id: 9,
          titulo: 'Ações',
          propriedade: 'tipo',
          ordem: 10,
          acoes: [
            { id: 1, nome: 'Visualizar processo', icone: 'fa-eye', codigo: 'VISUALIZAR_PROCESSO', ordem: 1, show: () => true }
          ]
        }
      ],
      idsProcessos: []
    }
  },

  computed: {
    filtrosDesabilitadosPorPlanilha () {
      return !!this.nomePlanilha
    },
    podeAplicar () {
      return !!(this.nomePlanilha || this.idMunicipio)
    },
    podeUsarFiltroAplicado () {
      return !!(this.nomePlanilhaAplicado || this.idMunicipio)
    },
    textoOrientacao () {
      return 'Selecione o município (obrigatório) e, se desejar, refine com os demais filtros; ou use a pesquisa por lote com planilha. Depois clique em Aplicar filtro para carregar a listagem de processos.'
    },
    bairrosDoMunicipio () {
      if (!this.idMunicipio || !this.mapListMunicipiosBairros.length) return []
      const vistos = new Set()
      const lista = []
      this.mapListMunicipiosBairros.forEach((map) => {
        if (map.municipio === this.idMunicipio && map.bairro && !vistos.has(map.bairro)) {
          vistos.add(map.bairro)
          lista.push({ nome: map.bairro })
        }
      })
      return lista
    },
    textoVazioTabela () {
      if (this.carregando) return 'Carregando...'
      if (!this.filtroObrigatorioAplicado) {
        return 'Aplique o filtro (município ou planilha) para carregar os processos.'
      }
      return 'Nenhum processo encontrado para o filtro aplicado.'
    },
    podeBaixarSelecionadosZip () {
      return !!(this.filtroObrigatorioAplicado &&
        Array.isArray(this.processosSelecionadosZip) &&
        this.processosSelecionadosZip.length > 0)
    },
    idsProcessosNaoElegiveisZip () {
      const lista = this.items || []
      return lista.filter((p) => !this.processoElegivelParaZip(p)).map((p) => p.id).filter((id) => id != null)
    },
    filtroListagem () {
      return {
        caixa: 'LISTAGEM_EXPORTACAO_PLANTA_MEMORIAL',
        pagina: this.listagemFiltro.pagina,
        ordem: this.listagemFiltro.ordem,
        ordemDirecao: this.listagemFiltro.ordemDirecao,
        municipio: []
      }
    },
    mensagemFiltroNaoAplicado () {
      return 'Aplique o filtro (município ou planilha) antes.'
    }
  },

  async created () {
    await this.carregarMunicipios()
    await this.carregarMapaBairros()
    await this.carregarSetores()
    await this.carregarSituacoes()
  },

  watch: {
    idMunicipio (novo, antigo) {
      if (novo !== antigo) {
        this.idReurbColetivo = null
        this.bairroSelecionado = null
        this.quadraSelecionada = null
        this.quadras = []
        this.reurbColetivos = []
        if (!novo) {
          this.setorSelecionado = null
          this.statusSelecionado = null
          this.nomeInteressado = null
          this.cpfCnpjInteressado = null
          this.numeroProcessoFiltro = null
        }
        this.filtroObrigatorioAplicado = false
        this.nomePlanilhaAplicado = null
        this.items = []
        this.totalElements = 0
        this.listagemFiltro.pagina = 0
        this.processosSelecionadosZip = []
        if (novo) {
          this.carregarReurbs(novo)
        }
      }
    },
    idReurbColetivo () {
      this.processosSelecionadosZip = []
    },
    bairroSelecionado (novo, antigo) {
      this.processosSelecionadosZip = []
      if (novo !== antigo) {
        this.quadraSelecionada = null
        this.carregarQuadras()
      }
    },
    quadraSelecionada () {
      this.processosSelecionadosZip = []
    }
  },

  methods: {
    ...mapActions({
      findMunicipiosByEstadoAtual: 'municipios/findMunicipiosByEstadoAtual',
      buscarReurbColetivosPorMunicipio: 'modeloDespacho/buscarReurbColetivosPorMunicipio',
      findMunicipiosBairrosReurbIndividual: 'processo/findMunicipiosBairrosReurbIndividual',
      findQuadrasByMunicipioAndBairro: 'processo/findQuadrasByMunicipioAndBairro',
      findByFilterReurbIndividuais: 'processo/findByFilterReurbIndividuais',
      validarExportacaoPlantaMemorialComissao: 'processo/validarExportacaoPlantaMemorialComissao',
      getModeloRelatorio: 'dashboardRelatorios/downloadModelo'
    }),

    processoElegivelParaZip (p) {
      return !!(p && p.elegivelExportacaoZipPlantaMemorialComissao === true)
    },

    onSelectAllZip (list) {
      this.processosSelecionadosZip = Array.isArray(list) ? list : []
    },

    mapearOrdemBackend (prop) {
      if (prop === 'tipo') return 'tipo.nome'
      if (prop === 'status') return 'status'
      return prop
    },

    setDadosProcesso (item) {
      this.idProcesso = item.id
      this.numeroProcesso = item.numeroProcesso
      this.protocolo = item.numeroProtocolo
      this.tipoProcesso = item.tipoCodigo != null && item.tipoCodigo !== '' ? item.tipoCodigo : item.tipo
    },

    onExecutarListagem (payload) {
      if (payload && payload.acao && typeof this[payload.acao] === 'function') {
        this[payload.acao](this, payload)
      }
    },
    onAtualizarFiltroRapido () {},
    VISUALIZAR_PROCESSO (_this, { item }) {
      this.setDadosProcesso(item)
      this.showModalVisualizarProcesso = true
    },

    async onRefreshListagem () {
      await this.carregarDadosListagem()
    },
    onChangePage (newPage) {
      this.listagemFiltro.pagina = newPage - 1
      this.processosSelecionadosZip = []
      this.carregarDadosListagem()
    },
    formataSetor (prop) {
      return setoresFormatado[prop.setor]
    },
    async onSort (item) {
      this.listagemFiltro.ordem = this.mapearOrdemBackend(item.ordem)
      this.listagemFiltro.ordemDirecao = item.tipo
      this.listagemFiltro.pagina = 0
      this.processosSelecionadosZip = []
      await this.carregarDadosListagem()
    },

    exibirBuscaPorLote () {
      this.showPesquisaLote = !this.showPesquisaLote
    },

    onSuccess (id, resumableFile, fileKey) {
      this.file = {
        fileKey: fileKey,
        nomeOriginal: resumableFile.fileName,
        tamanho: resumableFile.size
      }
      this.nomePlanilha = this.file.fileKey
      this.idMunicipio = null
      this.idReurbColetivo = null
      this.bairroSelecionado = null
      this.quadraSelecionada = null
      this.quadras = []
      this.setorSelecionado = []
      this.statusSelecionado = []
      this.nomeInteressado = null
      this.cpfCnpjInteressado = null
      this.numeroProcessoFiltro = null
      this.reurbColetivos = []
      this.filtroObrigatorioAplicado = false
      this.nomePlanilhaAplicado = null
      this.items = []
      this.totalElements = 0
      this.listagemFiltro.pagina = 0
      this.processosSelecionadosZip = []
    },

    removerDocumento () {
      this.file = null
      this.nomePlanilha = null
    },

    baixarModelo () {
      this.getModeloRelatorio()
    },

    listaFiltroOuNulo (lista) {
      return Array.isArray(lista) && lista.length > 0 ? lista : null
    },

    montarPayloadFiltros () {
      return {
        idMunicipio: this.idMunicipio,
        idProcessoReurbColetivo: this.idReurbColetivo || null,
        bairro: this.bairroSelecionado || null,
        quadra: this.quadraSelecionada || null,
        setor: this.listaFiltroOuNulo(this.setorSelecionado),
        status: this.listaFiltroOuNulo(this.statusSelecionado),
        nomeInteressado: this.nomeInteressado ? this.nomeInteressado.trim() : null,
        cpfCnpjInteressado: this.cpfCnpjInteressado ? this.cpfCnpjInteressado.trim() : null,
        numeroProcesso: this.numeroProcessoFiltro ? this.numeroProcessoFiltro.trim() : null
      }
    },

    montarPayloadListagem () {
      const base = {
        pagina: this.listagemFiltro.pagina,
        tamanhoPagina: CONFIGS.TAMANHO_PAGINACAO,
        ordem: this.listagemFiltro.ordem,
        ordemDirecao: this.listagemFiltro.ordemDirecao
      }
      if (this.nomePlanilhaAplicado) {
        return {
          ...base,
          nomePlanilha: this.nomePlanilhaAplicado,
          idProcessoReurbColetivo: null,
          idMunicipio: null,
          bairro: null,
          quadra: null
        }
      }
      return {
        ...base,
        ...this.montarPayloadFiltros(),
        nomePlanilha: null
      }
    },

    montarPayloadZip (idsProcessos) {
      let payload
      if (this.nomePlanilhaAplicado) {
        payload = { nomePlanilha: this.nomePlanilhaAplicado }
      } else {
        payload = {
          municipioId: this.idMunicipio,
          reurbColetivoProcessoId: this.idReurbColetivo || null,
          bairro: this.bairroSelecionado || null,
          quadra: this.quadraSelecionada || null,
          setor: this.listaFiltroOuNulo(this.setorSelecionado),
          status: this.listaFiltroOuNulo(this.statusSelecionado),
          nomeInteressado: this.nomeInteressado ? this.nomeInteressado.trim() : null,
          cpfCnpjInteressado: this.cpfCnpjInteressado ? this.cpfCnpjInteressado.trim() : null,
          numeroProcesso: this.numeroProcessoFiltro ? this.numeroProcessoFiltro.trim() : null
        }
      }
      if (idsProcessos != null && idsProcessos.length > 0) {
        payload.idsProcessos = idsProcessos
      }
      return payload
    },

    async baixarTodosZip () {
      this.processosSelecionadosZip = []
      await this.baixarZipComFiltro()
    },

    async baixarSelecionadosZip (processosSelecionadosZip) {
      this.processosSelecionadosZip = processosSelecionadosZip

      if (!this.filtroObrigatorioAplicado || !this.podeUsarFiltroAplicado) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, this.mensagemFiltroNaoAplicado)
        return
      }

      if (processosSelecionadosZip.length === 0) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Marque ao menos um processo elegível na listagem.')
        return
      }

      await this.baixarZipComFiltro()
    },

    async baixarZipComFiltro () {
      const idsProcessos = this.processosSelecionadosZip

      if (!this.filtroObrigatorioAplicado || !this.podeUsarFiltroAplicado) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, this.mensagemFiltroNaoAplicado)
        return
      }
      const payload = this.montarPayloadZip(idsProcessos)
      this.gerandoZip = true
      try {
        await this.baixarZipExportacaoPorPost(payload)
      } finally {
        this.gerandoZip = false
      }
    },

    mensagemErroRespostaExportacaoZip (corpoJson) {
      if (!corpoJson || typeof corpoJson !== 'object') {
        return null
      }
      if (corpoJson.message) {
        return corpoJson.message
      }
      if (Array.isArray(corpoJson.erros) && corpoJson.erros.length > 0) {
        return corpoJson.erros.join(' ')
      }
      return corpoJson.mensagem || null
    },

    async validarExportacaoZipAntesDownload (payload) {
      try {
        await this.validarExportacaoPlantaMemorialComissao(payload)
        return true
      } catch (err) {
        const mensagem =
          this.mensagemErroRespostaExportacaoZip(err) ||
          'Não foi possível validar a exportação para gerar o ZIP.'
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          mensagem
        )
        return false
      }
    },

    async baixarZipExportacaoPorPost (payload) {
      try {
        const authSalvo = getItem(KEYS.LOGIN.jwt) || ''

        const jwtDaSessao = typeof authSalvo === 'string'
          ? authSalvo.replace(/^\s*\S+\s+/, '').trim()
          : ''

        const base = process.env.ROOT_URL

        const params = new URLSearchParams()

        Object.entries(payload).forEach(([key, value]) => {
          if (value === null || value === undefined || value === '') {
            return
          }
          if (Array.isArray(value)) {
            value.forEach((item) => params.append(key, item))
          } else {
            params.set(key, value)
          }
        })

        params.set('access_token', jwtDaSessao)

        const pathRelativa =
          'processo/exportacaoPlantaMemorialComissao/download'

        const urlCompleta =
          `${base}${pathRelativa}?${params.toString()}`

        const valido = await this.validarExportacaoZipAntesDownload(payload)
        if (!valido) {
          return
        }

        const link = document.createElement('a')

        link.href = urlCompleta
        link.target = '_blank'

        document.body.appendChild(link)

        link.click()

        link.remove()
      } catch (e) {
        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERROR,
          'Falha ao realizar download do arquivo.'
        )
      }
    },

    labelReurb (reurb) {
      if (!reurb) return ''
      const num = reurb.numeroProcesso || ''
      const nome = reurb.nomeRazaoSocialInteressado || ''
      return nome ? `${num} — ${nome}` : String(num)
    },

    onClearMunicipio () {
      this.idMunicipio = null
    },

    async carregarMunicipios () {
      try {
        this.municipios = await this.findMunicipiosByEstadoAtual() || []
      } catch (e) {
        this.municipios = []
        this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, 'Erro ao carregar municípios')
      }
    },

    async carregarMapaBairros () {
      try {
        const response = await this.findMunicipiosBairrosReurbIndividual()
        this.mapListMunicipiosBairros = response || []
      } catch (e) {
        this.mapListMunicipiosBairros = []
      }
    },

    async carregarQuadras () {
      if (!this.idMunicipio || !this.bairroSelecionado) {
        this.quadras = []
        return
      }
      try {
        const lista = await this.findQuadrasByMunicipioAndBairro({
          municipioId: this.idMunicipio,
          bairro: this.bairroSelecionado
        })
        this.quadras = Array.isArray(lista) ? lista : []
      } catch (e) {
        this.quadras = []
      }
    },

    async carregarReurbs (municipioId) {
      try {
        const lista = await this.buscarReurbColetivosPorMunicipio(municipioId)
        this.reurbColetivos = lista || []
      } catch (e) {
        this.reurbColetivos = []
        this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, 'Erro ao carregar REURB coletivos')
      }
    },

    async carregarDadosListagem () {
      if (!this.podeUsarFiltroAplicado || !this.filtroObrigatorioAplicado) {
        this.items = []
        this.totalElements = 0
        return
      }
      this.carregando = true
      try {
        const res = await this.findByFilterReurbIndividuais(this.montarPayloadListagem())
        const inner = unwrapJson(res)
        const page = inner && (inner.data !== undefined ? inner.data : inner)
        this.items = (page && page.content) ? page.content : []
        this.totalElements = (page && typeof page.totalElements === 'number') ? page.totalElements : 0
      } catch (e) {
        this.items = []
        this.totalElements = 0
      } finally {
        this.carregando = false
      }
    },

    carregarSetores () {
      this.setores = listarSetoresFiltroExportacaoPlantaMemorial()
    },

    carregarSituacoes () {
      this.situacoes = listarSituacoesFiltroExportacaoPlantaMemorial()
    },

    async aplicarFiltro () {
      if (!this.podeAplicar) {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          'Selecione o município ou envie uma planilha na pesquisa por lote.'
        )
        return
      }
      if (this.nomeInteressado) {
        this.nomeInteressado = this.nomeInteressado.trim()
      }
      this.nomePlanilhaAplicado = this.nomePlanilha || null
      this.filtroObrigatorioAplicado = true
      this.listagemFiltro.pagina = 0
      this.processosSelecionadosZip = []
      await this.carregarDadosListagem()
    },

    limparFiltro () {
      this.idMunicipio = null
      this.idReurbColetivo = null
      this.bairroSelecionado = null
      this.quadraSelecionada = null
      this.quadras = []
      this.setorSelecionado = []
      this.statusSelecionado = []
      this.nomeInteressado = null
      this.cpfCnpjInteressado = null
      this.numeroProcessoFiltro = null
      this.reurbColetivos = []
      this.filtroObrigatorioAplicado = false
      this.nomePlanilhaAplicado = null
      this.showPesquisaLote = false
      this.removerDocumento()
      this.items = []
      this.totalElements = 0
      this.listagemFiltro.pagina = 0
      this.processosSelecionadosZip = []
      this.idsProcessos = []
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/element-variables.scss';

.card-container {
  margin-top: 0;
}

.painel-filtros {
  .titulo {
    margin: 0;
    padding: 12px 0 8px 0;
    font-size: 14px;
  }
  .full-width {
    width: 100%;
  }

  >>> .el-row--flex {
    flex-wrap: wrap;
  }

  >>> .select-tags-ellipsis {
    display: block;
    width: 100%;

    .el-input__inner {
      height: 40px !important;
      max-height: 40px !important;
    }

    .el-select__tags {
      flex-wrap: nowrap;
      max-width: calc(100% - 30px);
    }

    .el-select__input {
      flex-grow: 0 !important;
      width: 8px !important;
      max-width: 20px !important;
      margin-left: 4px;
    }

    .el-select__tags > span > .el-tag:first-child {
      display: inline-flex;
      align-items: center;
      max-width: calc(100% - 50px);
      overflow: hidden;
      box-sizing: border-box;

      .el-select__tags-text {
        flex: 1 1 auto;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .el-select__tags > span > .el-tag + .el-tag {
      flex-shrink: 0;
    }
  }
}

.button-row {
  margin-top: 16px;
  text-align: right;
}

.mt-1 {
  margin-top: 16px;
}

.subtitulo {
  margin: 0 0 12px;
  font-size: 16px;
  font-weight: 600;
  color: #424242;
}

.busca {
  padding: 12px 0 8px 8px;
  text-align: left;
  color: $--color-primary !important;
  cursor: pointer;
  font-size: 14px;
  font-weight: normal;
}

.row {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.btn-download {
  text-decoration: underline;
  cursor: pointer;
  color: #f1f1f1;
}

.icon-info {
  font-size: 16px;
  margin: 0 0 5px 5px;
}

.icon {
  margin-right: 7px;
}

.obrigatorio {
  color: #f56c6c;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/listagem/ListagemExportacaoPlantaMemorialComissao.vue